export default `
  mutation checkAiProviderKey($provider: AiProvider!) {
    checkAiProviderKey(provider: $provider) {
      status
      mask
    }
  }
`
